import { useStyleConfig } from '@chakra-ui/react'

import { StackWidget, StackWidgetProps } from '../StackWidget/StackWidget'
import { createWidget } from '../widget-utils'

export interface PageHeaderContainerWidgetProps extends StackWidgetProps {
  children?: React.ReactNode
}

export const PageHeaderContainerWidget = ({
  children,
  gap,
  spacing,
  ...props
}: PageHeaderContainerWidgetProps) => {
  const styles = useStyleConfig('PageHeaderContainer', {})
  const stackSpacing = spacing ?? gap ?? '16px'

  return (
    <StackWidget __css={styles} spacing={stackSpacing} {...props}>
      {children}
    </StackWidget>
  )
}

export const PageHeaderContainerWidgetDefinition = createWidget(
  PageHeaderContainerWidget,
  {
    type: 'PageHeaderContainer',
  },
)
